import React from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import styled from 'styled-components';
import { ProductCard } from 'components/shared';
import { ProductType } from 'types';
import { theme, media } from 'styles';

const Wrapper = styled(FlipMove)`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  margin-bottom: 68px;

  ${media.laptop`
    margin-bottom: 118px;
  `};

  &:after {
    content: '';
    width: calc((100% - ${parseInt(theme.sp.xl, 10) * 2}px) / 3);
  }
`;

const CardWrapper = styled.div`
  margin-bottom: ${theme.sp.m};
  width: calc((100% - ${parseInt(theme.sp.m, 10)}px) / 2);

  ${media.desktop`
    margin-bottom: ${theme.sp.xl};
    width: calc((100% - ${parseInt(theme.sp.xl, 10) * 2}px) / 3);
  `};
`;

const propTypes = {
  products: PropTypes.arrayOf(ProductType).isRequired,
  selectedCategory: PropTypes.object.isRequired,
};

function List({ products, selectedCategory }) {
  let selectedProducts = products;
  if (selectedCategory) {
    selectedProducts = selectedCategory.productIds
      .map(id =>
        products.find(product => parseInt(product.id, 10) === parseInt(id, 10)),
      )
      .filter(product => product !== undefined);
  }

  return (
    <Wrapper>
      {selectedProducts.map(product => (
        <CardWrapper key={product.id}>
          <ProductCard product={product} />
        </CardWrapper>
      ))}
    </Wrapper>
  );
}

List.propTypes = propTypes;

export default List;



// WEBPACK FOOTER //
// ./src/components/ProductsPage/components/List/List.jsx